import React from "react";
import { Subscription } from "rxjs";
import appMessageService, {
  messageType,
} from "services/common-services/app-message-service";
import { authorizationService } from "services/common-services/authorization-service";
import { webService } from "services/common-services/web-service";

const AppWrapper = (props: any) => {
  const [subscription] = webService.useSubscription();

  React.useEffect(() => {
    const successSubscription: Subscription = appMessageService
      ._success()
      .subscribe(
        appMessageService.handleNotify({
          type: messageType.SUCCESS,
          title: "thanh cong",
        })
      ); // subscribe success

    const errorSubscription: Subscription = appMessageService
      ._error()
      .subscribe(
        appMessageService.handleNotify({
          type: messageType.ERROR,
          title: "that bai",
        })
      ); // subscribe error

    subscription.add(successSubscription);
    subscription.add(errorSubscription);
  }, [subscription]); // subcribe appMessageService

  authorizationService.useAuthorizedApp();

  return <>{props.children}</>;
};

export default AppWrapper;
